// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
// import axios from 'axios'
import router from './router'
import { getLan, getImg, isEn } from './i18n/i18nLan'

Vue.config.productionTip = false
//引入element-ui
Vue.use(ElementUI)

/* eslint-disable no-new */
Vue.directive('click-out', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

let bus = {
  nowLan: navigator.language
};
new Vue({
  data () {
      return {
          $$state: {
              bus
          }
      }
  },
});

Vue.prototype.getLan = getLan
Vue.prototype.getImg = getImg
Vue.prototype.isEn = isEn
Vue.prototype.bus = bus;

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js